import React, { useState } from 'react';
import { Link } from 'gatsby';
import styled from '@emotion/styled';
import { colors, device } from '../GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { navMenu } from './navMenu';

interface Props {
    active: boolean;
}

const StyledNav = styled.div<Props>`
    height: 8vh;
    z-index: 200;
    width: 100vw;
    position: fixed;
    nav {
        padding: 1em 1em;
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
            cursor: pointer;
        }
        .burger {
            display: flex;
            flex-direction: column;
            align-items: end;
            .line-one {
                min-width: ${({ active }) => (active ? `23px` : `15px`)};
                transform: ${({ active }) =>
                    active ? `rotate(45deg) translateX(-2px) translateY(10px)` : `rotate(0deg)`};
            }
            .line-three {
                transform: ${({ active }) =>
                    active ? `rotate(135deg) translateX(-4px) translateY(16px)` : `rotate(0deg)`};
                min-width: ${({ active }) => (active ? `23px` : `15px`)};
            }
            .line-two {
                opacity: ${({ active }) => (active ? `0` : `1`)};
            }
            .line-one {
                width: 18px;
            }
            .line-two {
                width: 24px;
            }
            .line-three {
                width: 15px;
            }
            div {
                z-index: 2;
                border-radius: 10px;
                background: ${({ active }) => (active ? `${colors.white}` : `${colors.navy}`)};
                height: 3.5px;
                width: 10px;
                margin: 0.2em;
            }
        }
        .nav-item {
            position: relative;
            div {
                right: 1.5em;
            }
        }
        .desktop-menu-container {
            position: relative;
        }
        .mobile-menu {
            z-index: -1;
            top: 0em;
            left: 0em;
            transform: ${({ active }) => (active ? 'translateX(00%)' : 'translateX(100%)')};
            width: 100vw;
            height: 100vh;
            position: absolute;
            display: flex;

            justify-content: center;
            background: ${colors.navy};
            .mobile-menu-container {
                margin-top: 9em;
            }
            .mobile-nav-item {
                display: flex;
                width: 170px;
                position: relative;
                align-items: center;
                .arrow {
                    position: absolute;
                    left: 8em;
                }
            }

            li {
                list-style: none;
                margin: 1em 0em;
                color: ${colors.white};
                font-weight: 900;
            }
        }

        .desktop-dropdown {
            border-radius: 0px 0px 16px 16px;
            top: 4.05em;
            width: 300px;
            padding: 1em 4em 1em 2.3em;
            display: none;
            background: ${colors.blue};
            position: absolute;
            .dropdown-item {
                &:hover {
                    opacity: 0.7;
                }
                transition: 0.2s ease-in;
                font-weight: 500;
                list-style: none;
                margin: 1em 0em;
            }
        }
        .mobile-logo {
            width: 54.3px;
            height: 64px;
        }
    }
    .desktop-logo {
        display: none;
    }
    .item-container {
        display: none;
    }
    .desktop-menu {
        display: none;
    }
    @media ${device.tablet} {
        background: ${colors.navy};
        height: 100px;
        padding: 0em 3em;
        .desktop-logo {
            display: block;
        }
        .mobile-logo {
            display: none;
        }
        .burger {
            display: none;
            div {
                display: none;
            }
        }

        nav {
            .item-container {
                display: flex;
                list-style: none;
                position: relative;
                .desktop-dropdown {
                    display: block;
                    background: ${colors.blue};
                    position: absolute;
                }
            }
            .desktop-menu {
                display: flex;
                list-style: none;
                li {
                    font-size: 20px;
                    color: ${colors.white};
                    font-weight: 800;
                    margin: 0em 2em;
                }
            }
        }
    }
`;

interface IMenuProps {
    active: boolean;
    name: string;
    menu: [{ name: string; path: string }] | undefined;
}

export const Nav = () => {
    const [desktopMenu, setDesktopMenu] = useState<IMenuProps>({
        active: false,
        name: '',
        menu: undefined,
    });
    const [mobileMenu, setMobileMenu] = useState<IMenuProps>({
        active: false,
        name: '',
        menu: undefined,
    });
    return (
        <>
            <StyledNav active={mobileMenu.active}>
                <nav>
                    <div>
                        <Link to="/">
                            <StaticImage
                                quality={100}
                                className="mobile-logo"
                                src="../../../images/svgs/logo-mobile.svg"
                                alt="smilecraft logo"
                                placeholder="none"
                            />
                        </Link>
                        <Link to="/">
                            <StaticImage
                                quality={100}
                                className="desktop-logo"
                                src="../../../images/svgs/logo-desktop.svg"
                                alt="smilecraft logo with text"
                                placeholder="none"
                            />
                        </Link>
                    </div>

                    <div>
                        <div
                            onClick={() =>
                                setMobileMenu({
                                    active: !mobileMenu.active,
                                    name: '',
                                    menu: undefined,
                                })
                            }
                            className="burger"
                        >
                            <div className="line-one"></div>
                            <div className="line-two"></div>
                            <div className="line-three"></div>
                        </div>

                        <ul className="mobile-menu">
                            <div className="mobile-menu-container">
                                {!mobileMenu.menu &&
                                    navMenu.map(item => {
                                        if (item.menu) {
                                            return (
                                                <div
                                                    onClick={() =>
                                                        setMobileMenu({
                                                            active: true,
                                                            name: item.name,
                                                            menu: item.menu,
                                                        })
                                                    }
                                                    className="mobile-nav-item"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <li>{item.name}</li>
                                                    <StaticImage
                                                        className="arrow"
                                                        alt="arrow point down"
                                                        placeholder="none"
                                                        quality={100}
                                                        src="../../../images/svgs/arrow-down-white.svg"
                                                    />
                                                </div>
                                            );
                                        } else {
                                            return (
                                                <div
                                                    onMouseEnter={() =>
                                                        setDesktopMenu({
                                                            active: false,
                                                            name: '',
                                                            menu: undefined,
                                                        })
                                                    }
                                                    className="mobile-nav-item"
                                                >
                                                    <Link
                                                        onClick={() =>
                                                            setMobileMenu({
                                                                active: false,
                                                                name: '',
                                                                menu: undefined,
                                                            })
                                                        }
                                                        to={`${item.path}`}
                                                    >
                                                        <li>{item.name}</li>
                                                    </Link>
                                                </div>
                                            );
                                        }
                                    })}
                                {/* {mobileMenu.name === 'Services' && (
                                    <h4
                                        onClick={() =>
                                            setMobileMenu({ active: true, name: '', menu: '' })
                                        }
                                        style={{
                                            textDecoration: 'underline',
                                            fontSize: '20px',
                                            color: `${colors.white}`,
                                        }}
                                    >
                                        Services
                                    </h4>
                                )} */}
                                {
                                    <h4
                                        onClick={() =>
                                            setMobileMenu({ active: true, name: '', menu: '' })
                                        }
                                        style={{
                                            textDecoration: 'underline',
                                            fontSize: '20px',
                                            color: `${colors.white}`,
                                        }}
                                    >
                                        {mobileMenu.name && mobileMenu.name}
                                    </h4>
                                }

                                {mobileMenu.menu &&
                                    mobileMenu.menu.map(item => {
                                        return (
                                            <Link to={`${item.path}`}>
                                                <div
                                                    onClick={() =>
                                                        setMobileMenu({
                                                            active: false,
                                                            name: '',
                                                            menu: '',
                                                        })
                                                    }
                                                    className="mobile-nav-item"
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <li key={item.name}>{item.name}</li>
                                                </div>
                                            </Link>
                                        );
                                    })}
                            </div>
                        </ul>

                        <ul className="desktop-menu">
                            <div className="item-container">
                                {navMenu.map(item => {
                                    if (item.menu) {
                                        return (
                                            <div
                                                onMouseEnter={() =>
                                                    setDesktopMenu({
                                                        active: true,
                                                        name: item.name,
                                                        menu: item.menu,
                                                    })
                                                }
                                                className="nav-item"
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <li>{item.name}</li>
                                                <StaticImage
                                                    alt="arrow point down"
                                                    placeholder="none"
                                                    quality={100}
                                                    src="../../../images/svgs/arrow-down-white.svg"
                                                />
                                            </div>
                                        );
                                    } else {
                                        return (
                                            <div
                                                onMouseEnter={() =>
                                                    setDesktopMenu({
                                                        active: false,
                                                        name: '',
                                                        menu: undefined,
                                                    })
                                                }
                                                className="nav-item"
                                            >
                                                <Link to={item.path}>
                                                    <li>{item.name}</li>
                                                </Link>
                                            </div>
                                        );
                                    }
                                })}

                                {desktopMenu.menu && desktopMenu.name === 'Services' && (
                                    <ul
                                        onMouseLeave={() =>
                                            setDesktopMenu({
                                                active: false,
                                                name: '',
                                                menu: undefined,
                                            })
                                        }
                                        className="desktop-dropdown"
                                    >
                                        {desktopMenu.menu.map(item => {
                                            return (
                                                <Link to={item.path}>
                                                    <li className="dropdown-item">{item.name}</li>
                                                </Link>
                                            );
                                        })}
                                    </ul>
                                )}
                                {desktopMenu.menu && desktopMenu.name === 'Blog' && (
                                    <ul
                                        style={{ right: '-2em' }}
                                        onMouseLeave={() =>
                                            setDesktopMenu({
                                                active: false,
                                                name: '',
                                                menu: undefined,
                                            })
                                        }
                                        className="desktop-dropdown"
                                    >
                                        {desktopMenu.menu.map(item => {
                                            return (
                                                <Link to={item.path}>
                                                    <li className="dropdown-item">{item.name}</li>
                                                </Link>
                                            );
                                        })}
                                    </ul>
                                )}

                                {desktopMenu.menu && desktopMenu.name === 'For Patients' && (
                                    <ul
                                        style={{ left: '12em' }}
                                        onMouseLeave={() =>
                                            setDesktopMenu({
                                                active: false,
                                                name: '',
                                                menu: undefined,
                                            })
                                        }
                                        className="desktop-dropdown"
                                    >
                                        {desktopMenu.menu.map(item => {
                                            return (
                                                <Link to={item.path}>
                                                    <li className="dropdown-item">{item.name}</li>
                                                </Link>
                                            );
                                        })}
                                    </ul>
                                )}
                            </div>
                        </ul>
                    </div>
                </nav>
            </StyledNav>
        </>
    );
};
